module.exports = __webpack_public_path__ + "img/hindi-lang.5cc85b76.svg";